import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import PageHeader from "components/headers/PageHeader";
import FooterCard from "components/footers/PageFooter";
import ErrorImg from "images/error.png"
import '../styles.css'

// Styled Components
const ErrorContainer = tw.div`flex flex-col items-center justify-center text-center px-4 mb-40 md:flex-row`;
const ErrorMessage = tw.h1`text-2xl md:text-4xl font-bold text-gray-700 mt-8 sm:mt-4`; // Added some margin for smaller screens
const ErrorImage = styled.img`${tw`w-full max-w-md mt-6 sm:mt-4`}`; // Decreased margin on smaller screens


export default () => {

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  return (
    <AnimationRevealPage>
      <PageHeader pageName="We'll be back !" titleName="" />
      <ErrorContainer>
        <ErrorMessage>There is some issue, <span className="textColorHeading">We'll be back soon.</span></ErrorMessage>
        <ErrorImage
          src={ErrorImg}
          alt="Error Illustration"
        />
      </ErrorContainer>
      <FooterCard />
    </AnimationRevealPage>
  );
};
